import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement("g", { clipPath: "url(#print-alt_svg__clip0_1594_4058)", fill: "#2d6ded" }, /* @__PURE__ */ a.createElement("path", { d: "M5.416 6a1 1 0 001-1V2h8.84l2.16 2.16V5a1 1 0 002 0V3.75a1 1 0 00-.29-.75L16.666.59a2 2 0 00-1.41-.59h-8.84a2 2 0 00-2 2v3a1 1 0 001 1zM21.166 7h-19a2.5 2.5 0 00-2.5 2.5V14a2.5 2.5 0 002.5 2.5h2.5v6.25A1.25 1.25 0 005.916 24h12a1.25 1.25 0 001.25-1.25V16.5h2a2.5 2.5 0 002.5-2.5V9.5a2.499 2.499 0 00-2.5-2.5zm-18 4.5a1 1 0 110-2 1 1 0 010 2zm14 10a.5.5 0 01-.5.5h-9.5a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h9.5a.5.5 0 01.5.5v9z" }), /* @__PURE__ */ a.createElement("path", { d: "M14.666 14.75h-5.5a.75.75 0 100 1.5h5.5a.75.75 0 100-1.5zM12.916 18.25h-3.75a.75.75 0 100 1.5h3.75a.75.75 0 100-1.5z" })),
  /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", { id: "print-alt_svg__clip0_1594_4058" }, /* @__PURE__ */ a.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
), l = t;
export {
  l as default
};
